// Shared contact constants (from the deployed build).

export const IT_EMAIL = "it@kaden-sa.com";
export const HR_EMAIL = "hr@kaden-sa.com";
export const IT_PORTAL = "https://it.kaden-sa.com";
export const IT_EXTENSION = "310";
export const ORG_CHART_URL = "https://kadensa.sharepoint.com/sites/KadenGate/SitePages/Organization-Chart.aspx";
export const KADEN_GATE_URL = "https://kadensa.sharepoint.com/sites/KadenGate/";
export const VIVA_ENGAGE_URL = "https://engage.cloud.microsoft/main/org/kaden-sa.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI2NTM4NTc5OTY4MSJ9/all";
export const ITSM_URL = "https://it.kaden-sa.com";
